export default "__VITE_ASSET__VySxNck1__"